export default __webpack_public_path__ + "static/media/loanservice.f1178406.svg";